import { Button, Modal } from "react-bootstrap";
import useUsers from "../hooks/useUsers";
import { useEffect, useState } from "react";

const UsersAccountModal = ({ show, setShow, data, setData }) => {

    const [filters, setFilters] = useState({
        perPage: 10,
        search: '',
        exceptIds: [],
        page: 1
    });

    const [currentUsers, setCurrentUsers] = useState([]);

    const [{ users, total, numberOfPages, loading }, getUsers] = useUsers({ params: { ...filters }, options: { useCache: false } });

    useEffect(() => {
        setFilters((old) => {
            return {
                ...old,
                exceptIds: data?.users?.map(user => user?.id),
                page: 1
            }
        });

        setCurrentUsers([]);
    }, [data?.users]);

    useEffect(() => {
        if (users?.length) {
            setCurrentUsers((oldUsers) => {
                return [...oldUsers, ...users];
            });
        }
    }, [users])

    useEffect(() => {
        getUsers({
            params: filters
        });
    }, [filters]);

    return (
        <Modal size="lg" show={show} onHide={() => setShow(false)}>
            <Modal.Header closeButton>
                <Modal.Title>
                    Agregar usuarios
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>
                    <b>Importante:</b> solo agregue estos usuarios si quiere que sean los unicos que puedan realizar cambios en esta cuenta dentro de la planificación anual.
                </p>
                <input type="text" className="form-control mb-5" placeholder="Buscar..." value={filters?.search} onChange={(e) => {
                    setCurrentUsers([]);
                    setFilters(old => ({ ...old, search: e.target.value, page: 1 }))
                }} />
                {
                    currentUsers?.length > 0 ?
                        <ul>
                            {
                                currentUsers?.map((user, i) => {
                                    return (
                                        <li key={i} className="d-flex align-items-center gap-2 mb-2 border-bottom select-user" onClick={() => {
                                            setData((oldData) => {
                                                return {
                                                    ...oldData,
                                                    users: [...oldData?.users, user]
                                                }
                                            })
                                        }}>
                                            <img src={`${user?.imagePath}`} style={{ width: 40, height: 40 }} className="rounded-circle" />
                                            <div>
                                                <p className="mb-0">
                                                    {user?.name}
                                                </p>
                                                <p className="mb-0">
                                                    {user?.documentNumber}
                                                </p>
                                            </div>
                                        </li>
                                    )
                                })
                            }
                            {
                                numberOfPages > filters?.page && !loading ?
                                    <li className="text-center" onClick={() => {
                                        setFilters((old) => {
                                            return {
                                                ...old,
                                                page: old?.page + 1
                                            }
                                        })
                                    }}>
                                        <button className="btn btn-primary btn-xs">
                                            Cargar mas
                                        </button>
                                    </li>
                                    :
                                    null
                            }
                        </ul>
                        :
                        !loading ?
                            <div className="text-center">
                                No se encontrarón resultados
                            </div>
                            :
                            null
                }
                {
                    loading ?
                        <div>
                            <div className="spinner">
                                <div className="double-bounce1 bg-primary"></div>
                                <div className="double-bounce2 bg-primary"></div>
                            </div>
                        </div>
                        :
                        null
                }
            </Modal.Body>
            <Modal.Footer>
                <Button style={{ width: '100%' }} variant="danger" onClick={() => setShow(false)}>
                    Cerrar
                </Button>
            </Modal.Footer>
        </Modal >
    )
}

export default UsersAccountModal;